<section class="section-dash stats mb-4">
    <div class="stat-card">
        <h3>Total Invoices Generated</h3>
        <p>{{invoices().length}}</p>
    </div>
    <div class="stat-card">
        <h3>Active Clients</h3>
        <p>{{ activeClientsCount() }}</p>
    </div>
    @if(inactiveClientsCount() > 0){
        <div class="stat-card">
            <h3>Inactive Clients</h3>
            <p>{{ inactiveClientsCount() }}</p>
        </div>
    }
    <!-- <div class="stat-card">
        <h3>Inactive Clients</h3>
        <p>3</p>
    </div> -->
    @if(primaryCompany()){
        <div class="stat-card">
            <h3>Primary Company</h3>
            @if(primaryCompany()?.taxEnabled){
                <p class="enabled">GST Enabled</p>
            } @else {
                <p class="text-danger">GST Disabled</p>
            }
        </div>
    }
</section>

<div class="card shadow-sm mb-4">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">Latest Clients</h5>
            <a routerLink="/dashboard/clients" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="btn btn-outline-success btn-sm">
                View All
            </a>
        </div>

        <div class="table-responsive">
            @if((clients().length) > 0){
                <table class="table table-hover align-middle mb-0">
                    <thead class="table-light">
                        <tr>
                            <th>Name</th>
                            <th class="d-none d-sm-table-cell">Email</th>
                            <th>Status</th>
                            <!-- <th class="text-end">Action</th> -->
                        </tr>
                    </thead>

                    <tbody>
                        @for(item of clients(); track $index){
                            <tr>
                                <td>{{ item.name }} </td>
                                <td class="d-none d-sm-table-cell">{{ item.email }}</td>
                                <td>
                                    <span [className]="'badge ' + (item.isActive ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger')">
                                        {{ item.isActive ? "Active" : "Inactive"}}
                                    </span>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    </div>
</div>